import { useQuery } from "@tanstack/react-query";
import { type QueryFunctionContext } from "@tanstack/react-query";
import { type CustomerPacks } from "../../types/packs";
import packsDataService from "../../../Licensing/Packs/services/packsDataService";
import { type PerformanceFilter } from "features/Library/Common/utils/performanceUtils";

type QueryContextCustomerPacks = QueryFunctionContext<[_key: string, customerId: number, filter: PerformanceFilter]>;

export const getCustomerPacks = async ({ queryKey, signal }: QueryContextCustomerPacks): Promise<CustomerPacks[]> => {
  const [_key, customerId, filter] = queryKey;
  const { data } = await packsDataService.getCustomerPacks({ customerId, ...filter }, signal);
  return data;
};

export const useCustomerPacksQuery = (customerId: number, filter: PerformanceFilter, enabled = true) => {
  return useQuery({
    queryFn: getCustomerPacks,
    queryKey: ["customerPacks", customerId, filter] as const,
    enabled: enabled && !!customerId,
  });
};
